export { default } from "./SimilarPlayersTabContainer";
